import React from "react";
import Grid from '@mui/material/Grid2';
import {
    Box,
} from '@mui/material';
import './Breadcrumbs.css'
import { useTheme } from '@mui/material/styles';


const Breadcrumbs = () => {
	const theme = useTheme();

	return (
		<Box component="section" className="breadCrumbBox" style={{ backgroundColor: `${theme.palette.primary.main}` }}>
			<Grid container className="container" style={{padding:'16px'}}>
				<Grid item size={12} ></Grid>
			</Grid>
		</Box>
	);
}

export default Breadcrumbs;